// extracted by mini-css-extract-plugin
export default {"loading":"LoadingPage_loading__M7AxM"};